module.exports = __webpack_public_path__ + "29729723fda2ef2450460bf8a34ea0c1.png";